<!-- =========================================================================================
  File Name: InstituteView.vue
  Description: Institute View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-institute-view">

    <vs-alert color="danger" title="Institute Not Found" :active.sync="institute_not_found">
      <span>Institute record with instituteSeq: {{ this.instituteSeq }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'intituteList'}" class="text-inherit underline">All Institutes</router-link>
      </span>
    </vs-alert>

    <div id="institute-data" v-if="institute_data">

      <vx-card title="학원 상세 정보" class="mb-base">

        <!-- Avatar -->
        <div class="vx-row">

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="institute-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">학원명</td>
                <td>{{ institute_data.instituteName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">캠퍼스 명칭</td>
                <td>{{ institute_data.campusName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">사업자명</td>
                <td>{{ institute_data.contractorName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">사업자와의 관계</td>
                <td>{{ institute_data.contractorRelation }}</td>
              </tr>
              <tr>
                <td class="font-semibold">학원장명</td>
                <td>{{ institute_data.presidentName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">계약자와의 관계</td>
                <td>{{ institute_data.presidentRelation }}</td>
              </tr>
              <tr>
                <td class="font-semibold">사업자번호</td>
                <td>{{ institute_data.businessNumber }}</td>
              </tr>
              <tr>
                <td class="font-semibold">전화 번호</td>
                <td>{{ institute_data.telephone  }}</td>
              </tr>
              <tr>
                <td class="font-semibold">이동전화번호</td>
                <td>{{ institute_data.mobilephone  }}</td>
              </tr>
              <tr>
                <td class="font-semibold">팩스번호</td>
                <td>{{ institute_data.fax  }}</td>
              </tr>
              <tr>
                <td class="font-semibold">대표 이메일</td>
                <td>{{ institute_data.eMail }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">학원장ID</td>
                <td>{{ institute_data.instituteChiefID }}</td>
              </tr>
              <tr>
                <td class="font-semibold">우편번호</td>
                <td>{{ institute_data.zipCode }}</td>
              </tr>
              <tr>
                <td class="font-semibold">주소</td>
                <td>{{ institute_data.zipName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">주소세부</td>
                <td>{{ institute_data.zipDetail }}</td>
              </tr>
              <tr>
                <td class="font-semibold">가맹 계약일</td>
                <td>{{ institute_data.frContractDate }}</td>
              </tr>
              <tr>
                <td class="font-semibold">가맹 만료일</td>
                <td>{{ institute_data.frEndDate }}</td>
              </tr>
              <tr>
                <td class="font-semibold">최대 수강생수</td>
                <td>{{ institute_data.licenseCnt }}명</td>
              </tr>
              <tr>
                <td class="font-semibold">현재 수강생수</td>
                <td>{{ institute_data.studentCnt }}명</td>
              </tr>
              <tr>
                <td class="font-semibold">정보입력일</td>
                <td>{{ institute_data.createDate }}</td>
              </tr>
              <!-- <tr>
                <td class="font-semibold">검색주소</td>
                <td>{{ institute_data.addressSearch }}</td>
              </tr>
              <tr>
                <td class="font-semibold">홈페이지노출</td>
                <td>차단여부 : {{ institute_data.displayChk == 'Y'? '보여짐':'안보여짐'}}</td>
              </tr>
              <tr>
                <td class="font-semibold">도메인</td>
                <td>{{ institute_data.domain }}</td>
              </tr>
              <tr> -->
                <td class="font-semibold">캠퍼스 특이사항 메모</td>
                <td>{{ institute_data.memo }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex justify-end" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{name: 'institute-edit', params: { instituteSeq: this.instituteSeq }}">수정</vs-button>
            <!-- <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">삭제</vs-button> -->
          </div>
        </div>

      </vx-card>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vx-card title="만료일 관리">
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <h5>현재 만료일 : {{ institute_data.frEndDate }} </h5>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <span><h5 class="mb-2 text-danger">연장할 만료일을 선택하세요.</h5></span>
                <datepicker @selected="formatterFrEndDate" :language="languages.ko" format="yyyy-MM-dd"></datepicker>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <!-- <vs-button class="mr-3 mb-2">1개월 연장</vs-button> -->
                <vs-button class="mr-3 mb-2" @click="confirmAddLicenseDate">확인</vs-button>
              </div>
            </div>

          </vx-card>
        </div>
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vx-card title="수강권 관리">
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <h5>현재 수강권 : {{ institute_data.licenseCnt }}개 </h5>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <span><h5 class="mb-2 text-danger">추가할 수강권 수량을 입력하세요.</h5></span>
                <vs-input type="number" v-model="licenseCnt"/>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-button class="mr-3 mb-2" @click="confirmAddLicenseCount">확인</vs-button>
              </div>
            </div>

          </vx-card>
        </div>
      </div>  
    </div>
  </div>
</template>

<script>
import { fetchData, postData } from '@/api/module'
import Datepicker from 'vuejs-datepicker'
import * as lang from 'vuejs-datepicker/src/locale'
import moment from 'moment'

export default {
  components: {
    Datepicker
  },
  data () {
    return {
      licenseCnt: 1,
      frEndDate: '',
      languages: lang,
      institute_data: null,
      institute_not_found: false
    }
  },
  computed: {
    instituteSeq () {
      const seq = this.$route.params.instituteSeq
      if (seq === undefined) { 
        return this.$store.getters.getUserInfo.instituteSeq
      } else {
        return seq
      } 
    }
  },
  methods: {
    formatterFrEndDate (value) {
      const frEndDate = moment(value).format('YYYY-MM-DD')
      this.frEndDate = frEndDate
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.institute_data.instituteName}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      this.$router.push({name:'institute/institute-list'})
      this.showDeleteSuccess()
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Institute Deleted',
        text: 'The selected institute was successfully deleted'
      })
    },
    async loadItem () {
      try {
        const { data } = await fetchData(`institute/${this.instituteSeq}`)
        this.institute_data = data.data
        this.frEndDate = this.institute_data.frEndDate
        // console.log(data);

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    confirmAddLicenseCount () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: '수강권 추가',
        text: `수강권 "${this.licenseCnt}개"를 추가하시겠습니까?`,
        accept: this.addLicenseCount,
        acceptText: '확인'
      })
    },
    confirmAddLicenseDate () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: '만료일 연장',
        text: `만료일을 "${this.frEndDate}"로 변경하시겠습니까?`,
        accept: this.addLicenseDate,
        acceptText: '확인'
      })
    },
    async addLicenseCount () {

      try {
        await postData('institute/license', {
          instituteSeq: this.institute_data.instituteSeq,
          licenseType: 'COUNT',
          licenseValue: this.licenseCnt
        })
        this.loadItem()

      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    async addLicenseDate () {

      try {
        await postData('institute/license', {
          instituteSeq: this.institute_data.instituteSeq,
          licenseType: 'DATE',
          licenseValue: this.frEndDate
        })
        this.loadItem()

      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
 
  created () {
    this.loadItem()
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-institute-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}

</style>
